export enum GroupPeriod {
    Actual = 0,
    Pasado = 1,
    Anterior = 2
}
